import { Col } from "react-bootstrap";
import Value from "./Value";
import "./ValuesList.css";

function ValuesList({ values, handleShow, language }) {
  return (
    <Col className="values-list">
      {values.map((element) => (
        <Value
          key={element._id}
          id={element._id}
          title={element.title}
          titleEnglish={element.titleEnglish}
          description={element.description}
          descriptionEnglish={element.descriptionEnglish}
          handleShow={handleShow}
          language={language}
        />
      ))}
    </Col>
  );
}

export default ValuesList;
